export default {
  path: 'page/live/:classId/:courseId',
  props: true,
  component: resolve => require(['../../../pages/user/classin/page'], resolve)
}



// WEBPACK FOOTER //
// ./src/router/user/classin/pageLive.js